export default __webpack_public_path__ + "static/media/kaijuKingzCircle.cc73f298.png";